module.exports = __webpack_public_path__ + "static/mark-08c0fe57fb77924098ada45cd1b48e4f.png";